import SysDataTableExpand from "@/components/utils/dataTable/sysDataTableExpand/Index.vue";
import MenuContexto from "@/components/utils/MenuContexto.vue";
import Filtros from '@/components/Diagnostico/utils/Filtros.vue';
import FiltroPeriodoAnalise from '@/components/Diagnostico/SlowNoMoving/IndicadorEvolucao/Filtros/FiltroPeriodoAnalise.vue';
import SelecionarDatasParaComparacao from "@/components/Diagnostico/SlowNoMoving/IndicadorEvolucao/SelecionarDatasParaComparacao.vue";
import ComparacaoEntreDatas from "@/components/Diagnostico/SlowNoMoving/IndicadorEvolucao/ComparacaoEntreDatas.vue";
import DetalhesProduto from "@/components/produto/detalhes/Index.vue";
import DetalhamentoDuploClique from "@/components/Diagnostico/SlowNoMoving/IndicadorEvolucao/DetalhamentoDuploClique/Index.vue";
import Celula from "@/components/Diagnostico/SlowNoMoving/IndicadorEvolucao/Tabela/Celula.vue";

export const componentes = {
  SysDataTableExpand,
  MenuContexto,
  Filtros,
  FiltroPeriodoAnalise,
  SelecionarDatasParaComparacao,
  ComparacaoEntreDatas,
  DetalhesProduto,
  DetalhamentoDuploClique,
  Celula,
};
